import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { FieldsStore } from 'stores/fields';

export const useFieldsLoaded = (): { isFieldsLoaded: boolean } => {
  const fieldsStore = useSelector(
    ({ fields }: RootState) => fields,
    (newState, oldState) =>
      FieldsStore.loaded(newState) === FieldsStore.loaded(oldState),
  );

  return {
    isFieldsLoaded: FieldsStore.loaded(fieldsStore),
  };
};
